import { ReactNode, useEffect, useState } from 'react'

export function ClientGate({ children }: { children: ReactNode }) {
  const [clientSide, setClientSide] = useState<boolean>(false)

  useEffect(() => {
    setClientSide(true)
  }, [])

  if (!clientSide) return null

  return <>{children}</>
}
